import React from 'react'
import { connect } from 'react-redux'
import { chooseMonster, loadMonster, removeMonster } from '../../actions'
import MonsterSearch from '../components/MonsterSearch'
import Monster from './Monster/PF2/Monster'

import './Monsters.css'

const Monsters = props => {
  const {
    chooseMonster,
    error,
    loading,
    loadMonster,
    loadedMonster,
    removeMonster,
    selectedMonsters,
  } = props

  const renderLoading = () => {
    if (loading) {
      return <div>Loading...</div>
    }
  }

  const renderError = () => {
    if (error) {
      return <div>Error! {error.message}</div>
    }
  }

  const handleResultClick = suggestion => {
    chooseMonster(suggestion)
  }

  const handleLoadMonster = gameId => {
    loadMonster(gameId)
  }

  const handleRemoveMonster = gameId => {
    removeMonster(gameId)
  }

  return (
    <div className='Monsters'>
      {renderLoading()}
      {renderError()}

      <div className='Monsters__search'>
        <MonsterSearch label='Add Monster' onSelectMonster={handleResultClick} />

        <div className='Monsters__selected'>
          {selectedMonsters.map(monster => {
            const loadFn = handleLoadMonster.bind(null, monster.game_id)
            const removeFn = handleRemoveMonster.bind(null, monster.game_id)
            return (
              <div
                key={monster.game_id}
                className='Monsters__monster'
              >
                <span className='Monsters__monsterName' onClick={loadFn}>{monster.name}</span>
                <span className='Monsters__monsterRemove' onClick={removeFn}>x</span>
              </div>
            )
          })}
        </div>

        <div className='Monsters__detail'>
          {loadedMonster ? (
            <Monster />
          ) : (
            <div>
              Search for a monster above and add it to your list, then select it
              to see details here.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    error: state.monsters.error,
    loading: state.monsters.loading,
    loadedMonster: state.monsters.loadedMonster,
    selectedMonsters: state.monsters.selectedMonsters,
  }
}

const mapDispatchToProps = {
  chooseMonster,
  loadMonster,
  removeMonster,
}

export default connect(mapStateToProps, mapDispatchToProps)(Monsters)
